angular
    .module('cfn')
    .controller('dashboardController365', dashboardController365);

dashboardController365.$inject = [
    '$scope',
    '$rootScope',
    '$http',
    '$location',
    '$log',
    'i18nFilter',
    '$sce',
    'analyseService',
    '$dialog',
    '$timeout',
    '$filter',
    '$routeParams',
    'DemoAccountService',
    'cropPlanningChartService',
    'languageService',
    'tracker'
];

function dashboardController365(
    $scope,
    $rootScope,
    $http,
    $location,
    $log,
    i18nFilter,
    $sce,
    analyseService,
    $dialog,
    $timeout,
    $filter,
    $routeParams,
    DemoAccountService,
    cropPlanningChartService,
    languageService,
    tracker
) {
    if ($routeParams.redirectInfo === 'RegistrationConfirmed') {
      $rootScope.alertController.addTemporaryAlert(
        i18nFilter(
          'fe.register.success.confirmation.message',
          'Sie haben Ihre E-Mail-Adresse erfolgreich bestätigt.'
        ),
        'success'
      );
    }

    var controller = this;

    $scope.controller = this;
    $scope.dashboardController = this;
    $scope.financialAnalysisOfCompany = true;
    $scope.favorites = $rootScope.credentials.favorites;
    $scope.loaded = false;

    controller.resize = function() {
        $scope.display = {};
        $scope.display.showFinancials = $scope.financialAnalysisOfCompany;
        $scope.display.validatonErrorsBottom = true;
    };

    controller.currentDate = new Date();
    controller.pieChartData = null;
    controller.trackingLinkStart =
        '<a ng-click="controller.trackClick()" class="fn-link cropPieChartLink" href="#/core/field/">';
    controller.trackingLinkEnd = '</a>';

    controller.trackClick = function() {
        tracker.trackEvent('crop-view', 'dashboard', 'no-fields');
    };

    $scope.$on('windowResize', function() {
        controller.resize();
    });

    $scope.goto = function(addr) {
        $location.path(addr);
    };

    $scope.operationButtonClick = function(target) {
        ang.callAfter(function() {
            $('#' + target.id).scrollintoview({add: 65});
        });
    };

    // Controller-START ==============================

    preSelectYear();

    function preSelectYear() {
        $http
            .get('/365FarmNet/mod/booking-service/reporting/rest/v1.0/booking/sowing/current')
            .then(function(result) {
                $scope.cropOverview = result.data;
                controller.resize();
                if ($scope.cropOverview) {
                    var interMed = angular.copy($scope.cropOverview.results);
                    var gesSum = 0;
                    $.each(interMed, function(key, crops) {
                        if (crops.workedArea) {
                            gesSum = gesSum += crops.workedArea;
                        }
                    });
                    $.each(interMed, function(key, crops) {
                        if (gesSum > 0) {
                            crops.displayName = '<b>' + crops.displayName + '</b>';
                        }
                    });

                    $timeout(function() {
                        // Get the data for the fnChartPie
                        controller.pieChartData = cropPlanningChartService.getPieChartData(
                            interMed
                        );
                    }, 0);
                }
                $scope.loaded = true;
            });
    }

    return controller;
}

angular.module('cfn').directive('dWidget', function() {
    return {
        transclude: true,
        restrict: 'E',
        template: "<div class='widget' ng-transclude></div>",
        link: function(scope, element) {
            element.addClass('display-block');
        }
    };
});
